export enum TimerState {
  READY,
  RUNNING,
  PAUSED,
  FINISHED,
}
